import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    isSearchInProgress: false,
    sortBy: null,
    selectedCreator: null,
};
export const userInteractionsSlice = createSlice({
    name: "userInteractions",
    initialState,
    reducers: {
        setSearchInProgress: (state, action) => {
            state.isSearchInProgress = action.payload;
        },
        setSortBy: (state, action) => {
            state.sortBy = action.payload;
        },
        setUserSelectedCreator: (state, action) => {
            state.selectedCreator = action.payload;
        },
    },
});
export const { setSearchInProgress, setSortBy, setUserSelectedCreator } = userInteractionsSlice.actions;
export default userInteractionsSlice.reducer;
